jQuery(document).ready(function () {

    var sliderLoop = true;

    // Initialize Tiny Slider
    jQuery(".tiny-slider.tiny-slider-photo-gallery").each(function () {
        var sliderId = jQuery(this).data('slider');
        var currentSlider = jQuery('.tiny-slider.tiny-slider-photo-gallery.' + sliderId).parents('.photo-gallery-container');
        var photoGallerySlider = tns({
            container: '.tiny-slider.tiny-slider-photo-gallery.' + sliderId,
            items: 1,
            slideBy: 'page',
            autoplay: false,
            mouseDrag: true,
            controls: false,
            gutter: 40,
            nav: false,
            responsive: {
                1024: {
                    items: 2
                }
            },
            loop: sliderLoop,
            onInit: function () {
                jQuery('.tiny-slider.tiny-slider-photo-gallery.' + sliderId).css({'opacity': 1});
            }
        });

        // Calculate slider indicators width based on how many there are
        var totalIndicators = currentSlider.find('.photo-gallery-navigation .bar .indicator').length;
        var indicatorWidth = 100 / totalIndicators;
        currentSlider.find('.photo-gallery-navigation .bottom .bar .indicator').css({'width': ((indicatorWidth <= 6) ? '8px' : indicatorWidth + '%')});

        // Navigation
        photoGallerySlider.events.on('transitionEnd', function (data) {
            // Current slide - text

            currentSlider.find('.photo-gallery-navigation .current-no').text(data.displayIndex);
            // Current slide - indicator
            currentSlider.find('.photo-gallery-navigation .indicator').removeClass('active');
            currentSlider.find('.photo-gallery-navigation .bar > div:nth-child(' + data.displayIndex + ')').addClass('active');
        });
        // Go to specific slide when clicking on navigation indicator
        currentSlider.find('.photo-gallery-navigation').on('click', '.indicator', function () {
            var indicatorNo = jQuery(this).data('slide-no');
            photoGallerySlider.goTo(indicatorNo);
        });
        // Controls
        currentSlider.find('.photo-gallery-navigation').on('click', '.prev', function () {
            photoGallerySlider.goTo('prev');
        });
        currentSlider.find('.photo-gallery-navigation').on('click', '.next', function () {
            photoGallerySlider.goTo('next');
        });
    });

});